import { render, staticRenderFns } from "./consultant_item.vue?vue&type=template&id=fee1392e&scoped=true&"
import script from "./consultant_item.vue?vue&type=script&lang=ts&"
export * from "./consultant_item.vue?vue&type=script&lang=ts&"
import style0 from "./consultant_item.vue?vue&type=style&index=0&id=fee1392e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee1392e",
  null
  
)

export default component.exports